import {
  type PlatformThemeConfig,
  type ThemeColorMode,
  type ThemeModeVariables,
  THEME_TOKEN_TO_CSS_VAR,
  resolveThemeForMode,
} from '../../shared/theme/platformTheme';

export function applyThemeVariables(variables: ThemeModeVariables): void {
  const root = document.documentElement;

  for (const [token, cssVar] of Object.entries(THEME_TOKEN_TO_CSS_VAR)) {
    const key = token as keyof ThemeModeVariables;
    const value = variables[key];
    if (value) {
      root.style.setProperty(cssVar, value);
    } else {
      root.style.removeProperty(cssVar);
    }
  }
}

export function clearThemeVariableOverrides(): void {
  const root = document.documentElement;
  for (const cssVar of Object.values(THEME_TOKEN_TO_CSS_VAR)) {
    root.style.removeProperty(cssVar);
  }
}

export function applyPlatformTheme(
  theme: PlatformThemeConfig | null,
  mode: ThemeColorMode
): void {
  if (!theme) {
    clearThemeVariableOverrides();
    return;
  }

  applyThemeVariables(resolveThemeForMode(theme, mode));
}
